module.exports = __webpack_public_path__ + "media/images/timbits-hockey-64fc4f22.png";